document.addEventListener('DOMContentLoaded', function () {

    function bindScroll(trigger, parent, target) {

        document.addEventListener('click', function (e) {

            const button = e.target.closest(trigger);

            if (!button) {
                return;
            }

            const parentElement = button.closest(parent);

            if (!parentElement) {
                return;
            }

            const targetElement = parentElement.querySelector(target);

            if (!targetElement) {
                return;
            }

            const stickyHeader = document.querySelector('.sticky-header');
            const offset = stickyHeader ? stickyHeader.offsetHeight : 0;

            window.scrollTo({
                top: targetElement.getBoundingClientRect().top + window.scrollY - offset,
                behavior: 'smooth'
            });

        });

    }

    bindScroll('.bff-pagination .bff-pagination__btn','.blog-listing-filter-section','.grid');
});